export default {
    create: {
        cancel: {
            button: 'Refuse to exchange',
            bvModal: 'Are you sure you want to cancel the registration of the exchange of goods?',
        },

        create: {
            headerTitle: 'Attention!',
            tooltip: 'The quantity of goods for exchange is not specified.',
            label: 'Form an exchange',
            h3: 'The data has been sent!',
            bvModal:
        'Confirm the completion of the exchange. After confirmation, it will be impossible to correct the data.',
        },

        form: {
            fields: {
                orderId: 'Order №',
                exchangeFio: "Client's full name",
                exchangePhone: "Customer's phone number",
                exchangeReasonId: 'Reason for the exchange',
                inspection: 'Inspection of the goods',
                defectsDescription: 'Description of marriage',
                exchangeComments: 'Comment',
            },

            exchangeReasons: {
                defect: 'Defective',
                notLike: 'The product did not fit',
            },
        },
    },

    index: {
        exchangeCheck: 'Making an exchange',
        exchangeList: 'List of exchange operations',
    },

    list: {
        filter: {
            filters: {
                id: 'Operation number',
                orderId: 'Order number',
                exchangeDate: 'Date of operation',
            },

            buttonClear: 'Clear',
        },
    },

    print: 'Printing an application for exchange/return of goods',

    view: {
        h1: 'Operation for the exchange of goods in the order № {orderId}',
        orderWithDate: '{id} от {date}',
    },
};